import { createReducer } from '@reduxjs/toolkit'
import { IStateCurrentStaffMember } from './TReducer'
import { Actions_CurrentStaffMember } from './Actions'

const initialState: IStateCurrentStaffMember = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerCurrentStaffMember = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_CurrentStaffMember.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_CurrentStaffMember.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_CurrentStaffMember.store.saveCurrentStaffMember, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_CurrentStaffMember.store.clearCurrentStaffMember, (state) => {
      state.data = null
    })
})

export default ReducerCurrentStaffMember
